import React from 'react';
import PropTypes from 'prop-types';
import Link from '~/components/Link/Link';
import ScrollMenu from '~/components/ScrollMenu/ScrollMenu';
import ScrollMenuElement from '~/components/ScrollMenuElement/ScrollMenuElement';
import StyledComponent from '~/components/Styled/Styled';
// import get from 'lodash/get';

import { defineMessages, injectIntl, intlShape } from 'react-intl';
import css from '~/components/MatchupMenu/MatchupMenu.scss';

const messages = defineMessages({
  matchup: {
    id: 'matchup_menu.matchup',
    defaultMessage: 'MATCHUP',
  },
  preview: {
    id: 'matchup_menu.preview',
    defaultMessage: 'PREVIEW',
  },
  recap: {
    id: 'matchup_menu.recap',
    defaultMessage: 'RECAP',
  },
  stats: {
    id: 'matchup_menu.stats',
    defaultMessage: 'STATS',
  },
  tournament: {
    id: 'matchup_menu.tournament',
    defaultMessage: 'TOURNAMENT',
  },
});

/* eslint-disable react/prefer-stateless-function */
class MatchupMenu extends React.PureComponent {
  NCAABTournamentLink(eventRoute, currentSection) {
    const { intl: { formatMessage } } = this.props;
    return (
      <div className={css.mobileView}>
        <Link route={`${eventRoute}/tournament`}>
          <a className={css.link}>
            <ScrollMenuElement
              name={formatMessage(messages.tournament)}
              selected={currentSection === 'tournament'}
            />
          </a>
        </Link>
      </div>
    );
  }

  render() {
    const { event, currentSection, intl: { formatMessage } } = this.props;
    const postGame = event.event_status === 'final';
    const articleSectionName = postGame
      ? formatMessage(messages.recap)
      : formatMessage(messages.preview);

    // const hasStats = get(event, 'box_score.has_statistics', false);
    const eventRoute = `/${event.league.slug}/events/${event.id}`;

    const showPreview = (postGame && event.recap) || (!postGame && event.preview);

    const tournamentLink =
      event.league.slug === 'ncaab' ? this.NCAABTournamentLink(eventRoute, currentSection) : null;

    return (
      <ScrollMenu>
        <Link route={eventRoute}>
          <a className={css.link}>
            <ScrollMenuElement
              name={formatMessage(messages.matchup)}
              selected={currentSection === 'matchup'}
              ariaCurrent={currentSection === 'matchup' ? 'page' : null}
            />
          </a>
        </Link>
        {tournamentLink}
        {/* {hasStats && (
          <Link route={`${eventRoute}/stats`}>
            <a className={css.link}>
              <ScrollMenuElement
                name={formatMessage(messages.stats)}
                selected={currentSection === 'stats'}
                ariaCurrent={currentSection === 'stats' ? 'page' : null}
              />
            </a>
          </Link>
        )} */}
        {showPreview && (
          <Link route={`${eventRoute}/${articleSectionName}`}>
            <a className={css.link}>
              <ScrollMenuElement
                name={articleSectionName}
                selected={currentSection === articleSectionName}
                ariaCurrent={currentSection === articleSectionName ? 'page' : null}
              />
            </a>
          </Link>
        )}
      </ScrollMenu>
    );
  }
}

MatchupMenu.propTypes = {
  event: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  currentSection: PropTypes.string,
};

MatchupMenu.defaultProps = {
  currentSection: 'matchup',
};

MatchupMenu.displayName = 'MatchupMenu';

export default injectIntl(StyledComponent(MatchupMenu, [css]));
